module.exports = __webpack_public_path__ + "img/pngwing.com.aa39525c.png";